// extracted by mini-css-extract-plugin
module.exports = {"option":"NoteFilter_option__8Q0jm","onlyBtn":"NoteFilter_onlyBtn__cZjiw","statusIcon":"NoteFilter_statusIcon__3md1J"};